import {
  useDispatch,
  useEffect,
  useState,
  useNavigate,
  useParams,
  useSelector,
  titleToUrl,
} from '../../../imports/generalImport';
import { Box, Container, Button } from '../../../imports/muiImport';
import { setProductDetails, wipeOutProductDetails } from '../../../store/productInfo/action';
import { setNewDenomination, wipeOutDenomination } from '../../../store/productDetails/action';
import {
  createDenominationData,
  fetchProductById,
  isProductLive,
  validateOutOfStock,
} from '../../../pages/PRODUCTDETAILS/productDetailHook';
import { Helmet } from 'react-helmet-async';
import { Chip, CircularProgress, Typography } from '@mui/material';
import MobileProductDetailImage from '../../mobileComponents/mobileProductDetails/MobileProductDetailImage';
import christmasBGImage from '../../../assets/christmas_theme_assets/MobileProductDetail.png';
import MobileProductDetails from '../../mobileComponents/mobileProductDetails/MobileProductDetails';
import MobileGiftCardPurchase from '../../mobileComponents/mobileGiftCardPurchase/MobileGiftCardPurchase';
import ScrollToTop from '../../../components/other/ScrollToTop';
import PageNotFound from '../../../pages/OTHERPAGE/PageNotFound';
import RedeemableProduct from '../../mobileComponents/redeemableProducts/RedeemableProduct';
import { getUniqueClass, isDiscountedProduct } from '../../../hooks/utilsFn/utilsFn';

function MobileHomeProductDetails() {
  const [currentProductId, setCurrentProductId] = useState(null);
  const [productLoading, setProductLoading] = useState(true);
  const [outOfStock, setOutOfStock] = useState(null);
  const [showRangeDenomination, setShowRangeDenomination] = useState(false);
  const [productFound, setProductFound] = useState(false);

  const ProductDetail = useSelector((state) => state.ProductDetail?.allData);

  let { title: urlTitle, id: urlId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const canonicalUrl = `https://www.99gift.in/card-details/${urlId}/${titleToUrl(urlTitle)}`;

  useEffect(() => {
    setProductLoading(true);
    if (urlId != currentProductId) {
      dispatch(wipeOutProductDetails()); // clear product Details
      dispatch(wipeOutDenomination()); // clear previous denomination
      productload(urlId, urlTitle);
      setCurrentProductId(urlId);
    } else {
      // Redirect to home page
      navigate('/');
    }
  }, [urlId, urlTitle]);

  if (productFound) {
    return <PageNotFound />;
  }

  if (productLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          // minWidth: "100%",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <>
        <Helmet>
          <title>
            {ProductDetail?.['metaSEO']?.['metaTitle']
              ? ProductDetail?.['metaSEO']?.['metaTitle']
              : `Buy ${urlTitle} - 99gift.in`}
          </title>

          <meta
            property="og:title"
            content={
              ProductDetail?.['metaSEO']?.['metaOGTitle']
                ? ProductDetail?.['metaSEO']?.['metaOGTitle']
                : `Buy ${urlTitle} - 99gift.in`
            }
          />

          <meta
            name="description"
            content={
              ProductDetail?.['metaSEO']?.['metaDescription']
                ? ProductDetail?.['metaSEO']?.['metaDescription']
                : `Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`
            }
          />

          <meta
            name="og:description"
            content={
              ProductDetail?.['metaSEO']?.['metaOGDescription']
                ? ProductDetail?.['metaSEO']?.['metaOGDescription']
                : `Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`
            }
          />

          <meta property="og:url" content={canonicalUrl} />
          <link rel="canonical" href={canonicalUrl} />

          {ProductDetail?.['metaSchema'] && (
            <script type="application/ld+json">{ProductDetail?.['metaSchema']}</script>
          )}
        </Helmet>

        <Container
          sx={{
            minHeight: '100vh',
            backgroundColor: 'white.main',
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 1,
            mb: 6,
            p: 0,
          }}
        >
          <ScrollToTop />
          <Box
            sx={{
              width: '100%',
              position: 'relative',
              backgroundImage: `url(${christmasBGImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              overflow: 'hidden',
              pt: 2,
              pb: 6,
            }}
          >
            {/* Dark Overlay for readability */}
            <Box
              sx={{
                position: 'absolute',
                inset: 0,

                zIndex: 1,
              }}
            />

            {/* CONTENT */}
            <Box sx={{ position: 'relative', zIndex: 2 }}>
              <MobileProductDetailImage image={ProductDetail?.image} />

              <Box
                mt={3}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  maxWidth: '100%',
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    color: 'white.main',
                    fontSize: { xs: '4.5vw', sm: '2.5vw' },
                    fontWeight: 500,
                    textAlign: 'center',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                    mb: 2,
                    mt: -1,
                    px: 2,
                  }}
                >
                  {ProductDetail?.title}
                </Typography>

                <Chip
                  label={`${ProductDetail?.discount}% ${ProductDetail?.productType}`}
                  sx={{
                    px: '4px',
                    backgroundColor: 'white.main',
                    color: 'primary.main',
                    fontSize: {
                      xs: '3.8vw',
                      sm: '2vw',
                    },
                    boxShadow: 6,
                    mb: 1,
                  }}
                />
                <Typography
                  variant="h2"
                  sx={{
                    mt: 0,
                    color: 'white.main',
                    fontSize: {
                      xs: '3.1vw',
                      sm: '2vw',
                    },
                  }}
                >
                  *Terms & Condtions apply
                </Typography>
                <Box
                  sx={{
                    py: 2,
                    borderRadius: 3,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 1,
                      color: 'white.main',
                      fontSize: {
                        xs: '4.1vw',
                        sm: '2vw',
                      },
                      fontWeight: 500,
                      textTransform: 'capitalize',
                    }}
                  >
                    Redeemable at:
                  </Typography>
                  <RedeemableProduct
                    store={ProductDetail?.store}
                    website={ProductDetail?.website}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          <MobileProductDetails product={ProductDetail} />

          <Box
            sx={{
              position: 'fixed',
              bottom: 90,
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              py: 1,
              bgcolor: 'white.main',
              // backgroundColor: "transparent",
              zIndex: 1000,
            }}
          >
            {outOfStock ? (
              <Button
                variant="contained"
                fullWidth
                className={`${getUniqueClass(ProductDetail?.id, ProductDetail?.title)}`}
                sx={{
                  textTransform: 'capitalize',
                  bgcolor: 'error.main',
                  color: '#fff',
                  fontWeight: 'bold',
                  borderRadius: 0,
                  py: 1.5,
                  fontSize: '1.425rem',
                  boxShadow: 0,
                  '&:hover': {
                    bgcolor: 'error.dark',
                  },
                }}
              >
                Currently Out of Stock
              </Button>
            ) : (
              <MobileGiftCardPurchase showRangeDenomination={showRangeDenomination} />
            )}
          </Box>
        </Container>
      </>
    );
  }

  async function productload(urlId, urlTitle) {
    // TODO : Start Loading
    let mainData = {};
    const productFetched = await fetchProductById(urlId, urlTitle);
    const validateProductTitleResponse = validateProductTitle(productFetched?.data, urlTitle);
    const { productType, discount } = isDiscountedProduct(
      productFetched?.data?.discount,
      productFetched?.data?.cashback_amount
    );

    if (productFetched?.status && validateProductTitleResponse) {
      mainData = { ...productFetched.data };
      mainData.productType = productType;
      mainData.discount = discount;
      mainData.isCashbackProduct = productType === 'Cashback';
      dispatch(setProductDetails(mainData));
      const isProductLiveStatus = isProductLive(productFetched?.data.front);

      if (!isProductLiveStatus) {
        // This Porject is Live
        // Check Current Product Range or Denomination

        const isRange = productFetched?.data.isRange;
        // const apiId = productFetched?.data?.api_id;
        const front = productFetched?.data?.front;
        const denom = productFetched?.data?.denomination;
        const validateResponse = validateOutOfStock(isRange, front, denom);
        const outOfStockStatus = validateResponse.outOfStockStatus;
        const rangeDenominationStatus = validateResponse.rangeDenominationStatus;

        if (outOfStockStatus) {
          // this product is out of stock
          setOutOfStock(true);
          setProductLoading(false);
          return null;
        }

        if (rangeDenominationStatus) {
          // this product is Range
          setOutOfStock(false);
          setProductLoading(false);
          setShowRangeDenomination(true);
          return null;
        }

        if (!outOfStockStatus && !rangeDenominationStatus) {
          // this product denomination is already
          setOutOfStock(false);
          setProductLoading(false);
          setShowRangeDenomination(false);

          const newDeno = createDenominationData(productFetched?.data);
          dispatch(setNewDenomination(newDeno));
          return null;
        }
      } else {
        setOutOfStock(true);
        setProductLoading(false);
        return null;
      }
    } else {
      setProductFound(true);
    }

    // TODO : End Loading
    setProductLoading(false);
    return null;
  }

  function validateProductTitle(actualData, urlTitle) {
    const userGivenTitle = urlTitle?.toLowerCase();
    const ourProductTitle = actualData?.title?.toLowerCase();
    const ourFinalTitle = titleToUrl(ourProductTitle);

    if (ourFinalTitle === userGivenTitle) {
      setProductFound(false);
      return true;
    } else {
      setProductFound(true);
      return true;
    }
  }
}

export default MobileHomeProductDetails;
